import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Map from '../../Components/Maps'
import IdentificacionPrestador from '../../Components/FormFichaComponents/IdentificacionPrestador';
import DireccionPrestador from '../../Components/FormFichaComponents/DireccionPrestador';
import Dependencia from '../../Components/FormFichaComponents/Dependencia';
import {
    getDatosPrestadorFichasTecnicas,
    getDatosServiciosDeSaludFichasTecnicas,
    getDependenciasFichasTecnicas,
    getEF_AdministradorFichasTecnicas,
    getProvincias,
    getRegiones,
    getTipoAtencionFichasTecnicas,
    patchIdentificacionFichaTecnica
} from 'services/api';
import Spinner from '@jumbo/components/custom/Spinner';
import SharedTitle from '../../Components/SharedForms/SharedTitle';
import GuardarYSalirBtn from '../../Components/SharedForms/GuardarYSalirBtn';
import { formatRut, /* validateMail, validateRut, validateWebUrl */ } from '../../ConstsAndUtils/utils';
import HorarioPrestador from '../../Components/FormFichaComponents/HorarioPrestador';
import { ABIERTA, PRIVADOS, PUBLICOS, TEXT_COLOR_FT } from 'config/config';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import SharedWarning from '../../Components/SharedForms/SharedWarning';

import { Accordion, AccordionSummary, AccordionDetails, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { UseAccordion } from '../../Components/SharedForms/UseAccordion';

const IdentificacionPrestadorForm = (props) => {

    const publicoPrivado = sessionStorage.getItem("tipo_administracion")
    const abiertoCerrado = sessionStorage.getItem("tipo_atencion")

    const [id_ficha, setId_ficha] = useState(0)

    const [isLoading, setIsLoading] = useState(true)

    const [regionList, setRegionList] = useState([])
    const [regionListWithId, setRegionListWithId] = useState([])
    const [comunaList, setComunaList] = useState([])
    const [comunaListWithId, setComunaListWithId] = useState('')
    const [ciudadesList, setCiudadesList] = useState([])
    const [servicioSaludList, setServicioSaludList] = useState([])
    const [servicioSaludListWithId, setServicioSaludListWithId] = useState([])
    const [dependenciaList, setDependenciaList] = useState([])
    const [tipoAtencionList, setTipoAtencionList] = useState([])
    const [tipoAdministracionList, setTipoAdministracionList] = useState([])
    const [dependencia, setDependencia] = useState('')
    const [tipoAtencionDependencia, setTipoAtencionDependencia] = useState('')


    const [nombrePrestador, setNombrePrestador] = useState('')
    const [razonSocial, setRazonSocial] = useState('')
    const [rut, setRut] = useState('')
    const [codigoDeis, setCodigoDeis] = useState('')
    const [telefono, setTelefono] = useState('+569')
    const [correo, setCorreo] = useState('')
    const [web, setWeb] = useState('')

    const [servicioSalud, setServicioSalud] = useState('0a')
    const [administracionDependencia, setAdministracionDependencia] = useState('')
    const [administradorDependencia, setAdministradorDependencia] = useState('')
    const [clasificacion, setClasificacion] = useState('')
    const [complejidad, setComplejidad] = useState('')

    const [nombreCalle, setNombreCalle] = useState('')
    const [numeroCalle, setNumeroCalle] = useState('')
    const [comuna, setComuna] = useState('')
    const [ciudad, setCiudad] = useState('')
    const [region, setRegion] = useState('')
    const [direCompleta, setDireCompleta] = useState('')
    const [horario, setHorario] = useState('')
    const [dataHorario, setDataHorario] = useState('')

    const [reload, setReload] = useState(false)

    const geo = UseAccordion(false);
    const [checkMenu, setCheckMenu] = useState(0)

    /*     const complexityWithids = [
            {
                id: null,
                desc: "",
            },
            {
                id: 1,
                desc: "Baja",
            },
            {
                id: 2,
                desc: "Media",
            },
            {
                id: 3,
                desc: "Alta",
            }
        ] */

    useEffect(() => {

        getDatosServiciosDeSaludFichasTecnicas()
            .then(res => {
                let aux = []
                let aux2 = [""]
                res.data.map((item, index) => {
                    aux.push(item)
                    aux2.push(item.servicio_salud)
                    return null
                })
                setServicioSaludListWithId(aux)
                setServicioSaludList(aux2)
            })
            .catch(e => console.error(e))
            .finally(f => {
                getRegiones()
                    .then(res => {
                        let aux = [];
                        let aux2 = [];
                        res.data.map((item, index) => {
                            aux.push(item);
                            aux2.push(item.region_nombre);
                            return null;
                        });
                        setRegionListWithId(aux);
                        setRegionList(aux2);
                        //setRegionListPropietario(aux2)
                    })
                    .catch(e => console.error(e))
                    .finally(f => {
                        getProvincias()
                            .then(res => {
                                let aux = [];
                                res.data.map((item, index) => {
                                    aux = [...aux, ...item.comunas];
                                    return null;
                                });
                                setComunaListWithId(aux);
                            })
                            .catch(e => console.error(e))
                            .finally(f => {
                                getDependenciasFichasTecnicas()
                                    .then(res => {
                                        setDependenciaList(res.data);
                                    })
                                    .catch(e => console.error(e))
                                    .finally(f => {
                                        getTipoAtencionFichasTecnicas()
                                            .then(res => {
                                                let aux = [""];
                                                res.data.map((item, index) => {
                                                    aux.push(item.tipo_atencion);
                                                    return null;
                                                });

                                                setTipoAtencionList(aux);
                                            })
                                            .catch(e => console.error(e))
                                            .finally(f => {
                                                getEF_AdministradorFichasTecnicas()
                                                    .then(res => {
                                                        let aux = [""];

                                                        res.data.map((item, index) => {

                                                            aux.push(item.administrador);
                                                            return null
                                                        });

                                                        setTipoAdministracionList(aux);
                                                    })
                                                    .catch(e => console.error(e))
                                                    .finally(f => {
                                                        getDatosPrestadorFichasTecnicas()
                                                            .then(res => {
                                                                setId_ficha(res.data.id_identidad)
                                                                setNombrePrestador(res.data.identidad.nombre_prestador);
                                                                setRut(formatRut(res.data.identidad.rut_prestador))
                                                                setRazonSocial(res.data.identidad.razon_social);
                                                                if (res.data.identidad.telefono_prestador) {
                                                                    if (res.data.identidad.telefono_prestador.startsWith('+569')) {
                                                                        setTelefono(res.data.identidad.telefono_prestador)
                                                                    } else {
                                                                        setTelefono('+569' + res.data.identidad.telefono_prestador)
                                                                    }
                                                                }

                                                                setCodigoDeis(res.data.identidad.codigo_deis);

                                                                if (res.data.identidad.servicio_salud_desc) {
                                                                    setServicioSalud(res.data.identidad.servicio_salud_desc.id)
                                                                }

                                                                if (res.data.identidad.administrador) {
                                                                    setAdministradorDependencia(res.data.identidad.administrador.administrador)
                                                                }

                                                                if (res.data.identidad.nombre_administracion) {
                                                                    setAdministracionDependencia(res.data.identidad.nombre_administracion.nombre_administracion)
                                                                }else{
                                                                    setAdministracionDependencia('0a')
                                                                }

                                                                if (res.data.identidad.tipo_administracion) {
                                                                    setDependencia(res.data.identidad.tipo_administracion.tipo_administracion)
                                                                }

                                                                if (res.data.identidad.tipo_atencion) {
                                                                    setTipoAtencionDependencia(res.data.identidad.tipo_atencion.tipo_atencion)
                                                                }

                                                                if (res.data.identidad.complejidad_desc) {
                                                                    setComplejidad(res.data.identidad.complejidad_desc.id);
                                                                }else{
                                                                    setComplejidad('0a')
                                                                }

                                                                if (res.data.identidad.region_desc) {
                                                                    setRegion(res.data.identidad.region_desc.region_nombre);
                                                                }

                                                                if (res.data.identidad.comuna_desc) {
                                                                    setComuna(res.data.identidad.comuna_desc.id);
                                                                }

                                                                if (res.data.identidad.comuna_desc) {
                                                                    setCiudad(res.data.identidad.comuna_desc.comuna_provincia_id);//aca va la provincia

                                                                }

                                                                if (res.data.identidad.correo_prestador) {
                                                                    setCorreo(res.data.identidad.correo_prestador);
                                                                }

                                                                if (res.data.identidad.nombre_calle) {
                                                                    setNombreCalle(res.data.identidad.nombre_calle);
                                                                }

                                                                if (res.data.identidad.numero_calle) {
                                                                    setNumeroCalle(res.data.identidad.numero_calle);
                                                                }

                                                                if (res.data.identidad.tipo_prestador) {
                                                                    setClasificacion(res.data.identidad.tipo_prestador.tipo_prestador)
                                                                }
                                                                setDireCompleta(res.data.identidad.nombre_calle + ' ' + res.data.identidad.numero_calle + ' ' + res.data.identidad.comuna_desc.comuna_nombre)

                                                                if (res.data.identidad.web) {
                                                                    setWeb(res.data.identidad.web)
                                                                }

                                                                if (res.data.identidad.horario) {
                                                                    let aux = JSON.parse(res.data.identidad.horario)

                                                                    Object.entries(aux).forEach(([key, value]) => {
                                                                        setDataHorario(prevDataHorario => ({
                                                                            ...prevDataHorario,
                                                                            [key]: value
                                                                        }));
                                                                    });

                                                                } else {
                                                                    let extra = {
                                                                        e_lunes_jueves: '07:00',
                                                                        s_lunes_jueves: '22:00',
                                                                        e_viernes: '0a',
                                                                        s_viernes: '0a',
                                                                        e_sabados: '0a',
                                                                        s_sabados: '0a',
                                                                        e_domingos: '0a',
                                                                        s_domingos: '0a',
                                                                        e_festivos: '0a',
                                                                        s_festivos: '0a'
                                                                    }

                                                                    Object.entries(extra).forEach(([key, value]) => {
                                                                        setDataHorario(prevDataHorario => ({
                                                                            ...prevDataHorario,
                                                                            [key]: value
                                                                        }));
                                                                    });
                                                                }
                                                            })
                                                            .catch(e => console.error(e))
                                                            .finally(f => {

                                                                if (!!sessionStorage.getItem('dynamicMenu')) {
                                                                    setIsLoading(false)
                                                                } else {
                                                                    setCheckMenu(1)
                                                                }
                                                            });
                                                    })
                                            });
                                    })
                            });
                    });
            });


        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reload]);

    useEffect(() => {
        setIsLoading(true)
        if (checkMenu >= 1) {
            if (!!sessionStorage.getItem('dynamicMenu')) {
                setIsLoading(false)
            } else {
                const t = setTimeout(() => {
                    setCheckMenu(checkMenu + 1)
                }, 1500);

                return () => clearTimeout(t);
            }
        }

    }, [checkMenu])


    const guardar = () => {

        if (id_ficha !== 0) {
            setIsLoading(true)
            let idregion = regionListWithId.find(e => e.region_nombre === region)
            let idTipoAdministracion = dependenciaList.find(e => e.tipo_administracion === dependencia)
            let idTipoAtencion = null
            if (idTipoAdministracion) {
                idTipoAtencion = idTipoAdministracion.tipo_atencion.find(e => e.tipo_atencion === tipoAtencionDependencia)
            }
            let idAdministrador = null
            let idTipoPrestador = null
            if (idTipoAtencion) {
                idAdministrador = idTipoAtencion.administrador.find(e => e.administrador === administradorDependencia)
                idTipoPrestador = idTipoAtencion.tipo_prestadores_institucional.find(e => e.tipo_prestador === clasificacion)
            }

            let idNombreAdministracion = null

            if (idAdministrador) {
                idNombreAdministracion = idAdministrador.nombre_administracion.find(e => e.nombre_administracion === administracionDependencia)

            }

            let idServicioSalud = servicioSaludListWithId.find(e => e.id === parseInt(servicioSalud))

            let data = {
                "nombre_prestador": nombrePrestador,
                "rut_prestador": rut,
                "nombre_calle": nombreCalle,
                "numero_calle": numeroCalle,
                "razon_social": razonSocial,
                "correo_prestador": correo,
                "codigo_deis": codigoDeis,
                "telefono_prestador": telefono,
                "id_region": idregion ? idregion.region_id : null,
                "id_provincia": ciudad ? parseInt(ciudad) : null,
                "id_comuna": comuna ? parseInt(comuna) : null,
                "id_complejidad": complejidad,
                "id_tipo_administracion": idTipoAdministracion ? idTipoAdministracion.id : null,
                "id_tipo_atencion": idTipoAtencion ? idTipoAtencion.id : null,
                "id_administrador": idAdministrador ? idAdministrador.id : null,
                "id_nombre_administracion": idNombreAdministracion ? idNombreAdministracion.id : null,
                "id_tipo_prestador": idTipoPrestador ? idTipoPrestador.id : null,
                "id_servicio_salud": idServicioSalud ? idServicioSalud.id : null,
                "web": web,

            }

            if (validateIsCentro()) {
                data["horario"] = JSON.stringify(horario)
            }

            patchIdentificacionFichaTecnica(id_ficha, data)
                .then(res => {

                    Object.entries(horario).forEach(([key, value]) => {
                        setDataHorario(prevDataHorario => ({
                            ...prevDataHorario,
                            [key]: value
                        }));
                    });
                    toast.success("Datos guardados con éxito")
                    setReload(!reload)
                })
                .catch(e => {
                    console.error(e)
                    toast.error("Ocurrio un error al guardar los datos")
                })
                .finally(f => {
                    setIsLoading(false)
                })
        }


    }

    const validarHorario = (data) => {

        if (data) {
            const isValid = Object.values(data).every(value => value !== '')
            if (isValid) {
                setHorario(data)
            }
            return isValid
        } else {
            return false
        }


    }

    const isBtnDisabled = () => {
        if(complejidad!== '0a' && administracionDependencia !== '0a'){

            return false
        }
        else{
            return true
        }
    }

    /*     const isBtnDisabled = () => {
            if (
                nombrePrestador !== '' &&
                razonSocial !== '' &&
                validateRut(rut) &&
                codigoDeis !== '' &&
                (telefono !== '+569' && telefono.length === 12) &&
                validateMail(correo) &&
                validateWebUrl(web) &&
                region !== '' &&
                ciudad !== '0a' &&
                comuna !== '0a' &&
                nombreCalle !== '' &&
                numeroCalle !== '' &&
                servicioSalud !== '0a' &&
                tipoAtencionDependencia !== '0a' &&
                clasificacion !== '0a' &&
                complejidad !== '0a'
    
            ) {
    
                if (validateIsCentro()) {
                    if (horario !== '') {
                        return false
                    } else {
                        return true
                    }
    
                } else {
                    return false
                }
                //return false
            } else {
    
                return true
            }
        } */

    const validateIsCentro = () => {
        return !!(publicoPrivado === PUBLICOS && abiertoCerrado === ABIERTA) ||
            (publicoPrivado === PRIVADOS && abiertoCerrado === ABIERTA)
    }

    const showHorario = () => {
        if (validateIsCentro()) {
            return <HorarioPrestador
                validateHorario={validarHorario}
                editing={true}
                dataCrear={dataHorario}
            />
        } else {
            return null
        }

    }


    return (
        <>
            {

                isLoading ? <Spinner show={isLoading} />
                    :

                    <div style={{ width: '100%', flexBasis: '100%', paddingBottom: 10, color: TEXT_COLOR_FT, backgroundColor: 'white' }}>

                        <SharedTitle
                            title={'Identificación del prestador'}
                        />

                       {/*  <SharedWarning /> */}


                        <IdentificacionPrestador
                            nombre={nombrePrestador}
                            razon={razonSocial}
                            rut={rut}
                            codigo={codigoDeis}
                            telefono={telefono}
                            correo={correo}
                            setNombre={setNombrePrestador}
                            setRazon={setRazonSocial}
                            setRut={setRut}
                            setCodigo={setCodigoDeis}
                            setTelefono={setTelefono}
                            setCorreo={setCorreo}
                            web={web}
                            setWeb={setWeb}
                        />

                        <DireccionPrestador
                            servicioSaludList={servicioSaludList}
                            servicioSaludListWithId={servicioSaludListWithId}
                            setComunaList={setComunaList}
                            setCiudadesList={setCiudadesList}
                            listaComunas={comunaList}
                            listaCiudades={ciudadesList}
                            listaProvinciasWithId={regionListWithId}
                            listaComunasWithId={comunaListWithId}
                            listaRegiones={regionList}
                            nombreCalle={nombreCalle}
                            setNombreCalle={setNombreCalle}
                            numeroCalle={numeroCalle}
                            setNumeroCalle={setNumeroCalle}
                            comuna={comuna}
                            setComuna={setComuna}
                            ciudad={ciudad}
                            setCiudad={setCiudad}
                            region={region}
                            setRegion={setRegion}
                            servicioSalud={servicioSalud}
                            setServicioSalud={setServicioSalud}
                            setDireCompleta={setDireCompleta}
                        />

                        {/*                         <Grid
                            container
                            item
                            xs={12}
                            spacing={4}
                            style={{
                                backgroundColor: 'white',
                                paddingTop: 5,
                                borderRadius: 5,
                                paddingBottom: 5,
                                marginTop: 15,
                            }}>

                            <Grid item xs={12}>
                                <h3>Georeferencia</h3>
                                {direCompleta === '' ? null :
                                    <Map directions={direCompleta} />
                                }
                            </Grid>
                        </Grid> */}
                        <Accordion
                            elevation={0}
                            style={{ marginRight: 23, border: '1px solid #C2C2C2', marginLeft:25}}
                            expanded={geo.expanded}
                            onChange={geo.onChange}
                            sx={{ bgcolor: 'white', borderRadius: 1, mt: 2 }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <h3 style={{ margin: 0, color: 'rgb(23, 43, 77)', }}>Georeferencia</h3>
                            </AccordionSummary>

                            <AccordionDetails
                                sx={{
                                    p: 0,
                                    '& .MuiCollapse-wrapperInner': {
                                        marginLeft: '15px',
                                        marginBottom: '15px',
                                    },
                                }}
                            >
                                <Collapse in={geo.expanded} timeout="auto" unmountOnExit>
                                    <Grid
                                        container
                                        item
                                        xs={12}
                                        spacing={4}
                                        style={{
                                            backgroundColor: 'white',
                                            paddingTop: 5,
                                            borderRadius: 5,
                                            paddingBottom: 5,
                                            marginTop: 0,

                                        }}
                                    >
                                        <Grid item xs={12} sx={{ px: 2 }}>
                                            {direCompleta === '' ? null : <Map directions={direCompleta} />}
                                        </Grid>
                                    </Grid>
                                </Collapse>
                            </AccordionDetails>
                        </Accordion>



                        {
                            showHorario()
                        }



                        <Dependencia
                            dependenciaList={dependenciaList}
                            tipoAtencionList={tipoAtencionList}
                            tipoAdministracionList={tipoAdministracionList}
                            dependencia={dependencia}
                            setDependencia={setDependencia}
                            tipoAtencionDependencia={tipoAtencionDependencia}
                            setTipoAtencionDependencia={setTipoAtencionDependencia}
                            administracionDependencia={administracionDependencia}
                            administradorDependencia={administradorDependencia}
                            setAdministradorDependencia={setAdministradorDependencia}
                            setAdministracionDependencia={setAdministracionDependencia}
                            clasificacion={clasificacion}
                            setClasificacion={setClasificacion}
                            complejidad={complejidad}
                            setComplejidad={setComplejidad}
                        />
                        {
                            isLoading ?
                                null
                                :
                                <GuardarYSalirBtn
                                    moveLeft={true}
                                    click={guardar}
                                disabled={isBtnDisabled()}
                                />
                        }


                    </div >
            }

            <CustomToast />
        </>
    )

}

export default IdentificacionPrestadorForm